// extracted by mini-css-extract-plugin
export default {"container":"LabelWithValue_container__G4vYZ","valueAccentColor":"LabelWithValue_valueAccentColor__rHk0T"};